import React, { useState, useEffect, useContext } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import Modal from "@mui/material/Modal";
import { ListadoCreditoContext } from "../ListadoCredito";
import { LoaderScreen } from "../../components/LoaderScreen";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import { AnalisisCreditoFiltro } from "../../AnalisisCredito/AnalisisCreditoFiltro"; import { ModalPanelControlSolicitud } from "./Modales/ModalPanelControlSolicitud";
;

export const ListadoSolicitudesCredito = () => {
    const location = useLocation();
    const history = useHistory();
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const { state, setState } = useContext(ListadoCreditoContext);
    const [solicitudes, setSolicitudes] = useState({
        tablero: [],
        tabla: [],
        vendedores: [],
        sucursales: [],
    });
    const [filtroAbierto, setFiltroAbierto] = useState(false);
    const [openModalPC, setOpenModalPC] = useState(false);
    const [folioSolicitud, setFolioSolicitud] = useState("");



    // Obtener filtros del estado de la ubicación
    const filtrosIniciales = location.state?.filtros || {
        folio: "",
        asesor: "",
        razon_social: "",
        sucursal: "",
        estado: "",
        tipo_solicitud: ""
    };

    // Filtros
    const [filtroRazonSocial, setFiltroRazonSocial] = useState(filtrosIniciales.razon_social);
    const [filtroTipoSolicitud, setFiltroTipoSolicitud] = useState(filtrosIniciales.tipo_solicitud);
    const [filtroLineaCredito, setFiltroLineaCredito] = useState([]);
    const [filtroEstado, setFiltroEstado] = useState(filtrosIniciales.estado);
    const [filtroSucursal, setFiltroSucursal] = useState(filtrosIniciales.sucursal);
    const [filtroVendedor, setFiltroVendedor] = useState(filtrosIniciales.asesor);
    const [filtroFolio, setFiltroFolio] = useState(filtrosIniciales.folio);

    useEffect(() => {
        obtenerDatos()
    }, []);

    const obtenerDatos = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`AnalisisCreditoTablero/GetTableroCompleto`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setSolicitudes({
                    tablero: result.tablero,
                    tabla: result.tablero,
                    vendedores: result.vendedor,
                    sucursales: result.sucursal,
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("SOLICITUDES DE CREDITO", JSON.stringify(error), "error");
            });
    }

    useEffect(() => {
        if (solicitudes.tablero.length > 0) {
            onFiltrar(filtroFolio, filtroVendedor, filtroRazonSocial, filtroSucursal, filtroEstado, filtroTipoSolicitud);
        }
    }, [solicitudes.tablero]);

    const onOpenSolicitud = (folio) => {
        setFolioSolicitud(folio)
        setOpenModalPC(true)
    };


    const onFiltrar = (
        folio,
        asesor,
        razon_social,
        sucursal,
        estado,
        tipo_solicitud,
        linea_credito,
    ) => {
        return new Promise((resolve, reject) => {
            var newtabla = solicitudes.tablero;

            // Aplicar filtros a la tabla
            if (folio != undefined && folio !== null && folio != "") {
                newtabla = newtabla.filter((item) => item.folio === folio);
            } else {
                if (asesor != undefined && asesor !== null && asesor != "") {
                    newtabla = newtabla.filter((item) => item.vendedor === asesor);
                }
                if (razon_social != undefined && razon_social !== null && razon_social != "") {
                    newtabla = newtabla.filter((item) => item.razon_social === razon_social);
                }
                if (sucursal != undefined && sucursal !== null && sucursal != "") {
                    newtabla = newtabla.filter((item) => item.sucursal === sucursal);
                }
                if (estado != undefined && estado !== null && estado != "") {
                    newtabla = newtabla.filter((item) => item.estado === estado);
                }
                if (tipo_solicitud != undefined && tipo_solicitud !== null && tipo_solicitud != "") {
                    newtabla = newtabla.filter((item) => item.tipo_credito === tipo_solicitud);
                }
                if (linea_credito != undefined && linea_credito !== null && linea_credito != "") {
                    newtabla = newtabla.filter((item) => item.linea_credito === linea_credito);
                }
            }

            // Actualiza la tabla en el estado local
            setSolicitudes({ ...solicitudes, tabla: newtabla });
            resolve("");
            return;
        });
    };

    const capitalizeWords = (str) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
    };

    // Contador de solicitudes visibles
    const numeroDeSolicitudes = solicitudes.tabla.length;


    return (
        <PlantillaScreen
            titulo={" SOLICITUDES DE OPERACION ACTUALMENTE EN REVISION"}
            className={"prestamo-clientes-detalle-financiamiento-plantilla"}
            className_main={1}
        >
            {openModalPC && (
                <ModalPanelControlSolicitud
                    setOpenSolicitud={setOpenModalPC}
                    open={openModalPC}
                    setLoader={setLoader}
                    loader={loader}
                    folio={folioSolicitud}
                    titulo={"PANEL DE CONTROL"}
                    reiniciarPagina={obtenerDatos}
                    setFiltroRazonSocial={setFiltroRazonSocial}
                    setFiltroTipoSolicitud={setFiltroTipoSolicitud}
                    setFiltroLineaCredito={setFiltroLineaCredito}
                    setFiltroEstado={setFiltroEstado}
                    setFiltroSucursal={setFiltroSucursal}
                    setFiltroVendedor={setFiltroVendedor}
                    setFiltroFolio={setFiltroFolio}
                />
            )}
            <div className="analisis-solicitud-credito">
                <LoaderScreen loader={loader} />

                {solicitudes.tablero === undefined ||
                    solicitudes.tablero === null ||
                    solicitudes.tablero.length === 0 ? (
                    <div></div>
                ) : (
                    <div className="analisis-solicitud-credito-container">
                        <div className="analisis-solicitud-credito-container-filtros">
                            <AnalisisCreditoFiltro
                                tablero={solicitudes.tablero}
                                filtroRazonSocialB={filtroRazonSocial}
                                setFiltroRazonSocialB={setFiltroRazonSocial}
                                filtroTipoSolicitudB={filtroTipoSolicitud}
                                setFiltroTipoSolicitudB={setFiltroTipoSolicitud}
                                filtroLineaCreditoB={filtroLineaCredito}
                                setFiltroLineaCreditoB={setFiltroLineaCredito}
                                filtroEstadoB={filtroEstado}
                                setFiltroEstadoB={setFiltroEstado}
                                filtroSucursalB={filtroSucursal}
                                setFiltroSucursalB={setFiltroSucursal}
                                filtroVendedorB={filtroVendedor}
                                setFiltroVendedorB={setFiltroVendedor}
                                setFiltroFolioB={setFiltroFolio}
                                filtroFolioB={filtroFolio}
                                onFiltrar={onFiltrar}
                            />

                            <div className="contador-solicitudes">
                                Número de operaciones: {numeroDeSolicitudes}
                            </div>
                        </div>
                        <div className="analisis-solicitud-credito-container-table scroll-4">
                            <table cellPadding={0} cellSpacing={0}>
                                <thead>
                                    <tr className="tr-columnas">
                                        <th>Sucursal</th>
                                        <th>
                                            <div>Cliente</div>
                                        </th>
                                        <th>
                                            <div>Asesor de Venta</div>
                                        </th>
                                        <th>
                                            <div>Tipo de Solicitud</div>
                                        </th>
                                        <th>
                                            <div>Linea</div>
                                        </th>
                                        <th>
                                            <div>Estado</div>
                                        </th>
                                        <th>
                                            <div>Fecha</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {solicitudes.tabla.map((item) => (
                                        <tr
                                            onClick={() =>
                                                onOpenSolicitud(item.folio)
                                            }
                                        >
                                            <td>{capitalizeWords(item.sucursal)}</td>
                                            <td>{capitalizeWords(item.razon_social)}</td>
                                            <td>{item.vendedor}</td>
                                            <td>{capitalizeWords(item.tipo_credito)}</td>
                                            <td>{capitalizeWords(item.linea_credito)}</td>
                                            <td>{item.estado}</td>
                                            <td>{item.fecha}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </PlantillaScreen>
    );
};
